import { SVGFC } from '@repo/toolkit/types'

const ArrowLeftOneIcon: SVGFC = ({ color = 'white', ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.2278 5.82018L5.80889 11.2324C5.71022 11.3353 5.63288 11.4567 5.5813 11.5896C5.4729 11.8531 5.4729 12.1487 5.5813 12.4123C5.63288 12.5451 5.71022 12.6665 5.80889 12.7695L11.2278 18.1817C11.3289 18.2826 11.4488 18.3626 11.5809 18.4173C11.7129 18.4719 11.8544 18.5 11.9973 18.5C12.2859 18.5 12.5627 18.3855 12.7668 18.1817C12.9709 17.9778 13.0855 17.7014 13.0855 17.4131C13.0855 17.1249 12.9709 16.8484 12.7668 16.6446L9.1903 13.0834L17.4162 13.0834C17.7037 13.0834 17.9793 12.9693 18.1826 12.7663C18.3858 12.5633 18.5 12.288 18.5 12.0009C18.5 11.7138 18.3858 11.4385 18.1826 11.2355C17.9793 11.0325 17.7037 10.9185 17.4162 10.9185L9.1903 10.9185L12.7668 7.35725C12.8684 7.25662 12.949 7.1369 13.004 7.005C13.059 6.87309 13.0874 6.73161 13.0874 6.58872C13.0874 6.44582 13.059 6.30434 13.004 6.17243C12.949 6.04053 12.8684 5.92081 12.7668 5.82018C12.666 5.71873 12.5462 5.6382 12.4141 5.58324C12.282 5.52829 12.1404 5.5 11.9973 5.5C11.8542 5.5 11.7126 5.52829 11.5805 5.58325C11.4484 5.6382 11.3286 5.71873 11.2278 5.82018Z"
        fill={color}
      />
    </svg>
  )
}

export default ArrowLeftOneIcon
